module.exports = __webpack_public_path__ + "static/media/La La La (Love You Like).13e183f0.jpg";